import React from 'react';
import { Result, Button, Typography, Space } from 'antd';

const { Title, Paragraph } = Typography;

const UnsubscribeSuccessPage = () => {
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            background: '#f0f2f5',
            padding: '20px'
        }}>
            <div style={{
                background: '#fff',
                padding: '40px',
                borderRadius: '4px',
                textAlign: 'center',
                maxWidth: '600px',
                width: '100%',
                boxShadow: '0 1px 3px rgba(0,0,0,0.12)'
            }}>
                <Title level={1} style={{ fontSize: '72px', marginBottom: '20px' }}>:(</Title>
                <Title level={2}>It's sad to see you go</Title>

                <Paragraph style={{ marginTop: '40px' }}>
                    We hope to see you back!
                </Paragraph>

                <Space direction="vertical" size="large" style={{ marginTop: '40px', width: '100%' }}>
                    <Button type="primary" size="large" href="/" style={{ width: '200px' }}>
                        Return to Homepage
                    </Button>
                </Space>
            </div>
        </div>
    );
};

export default UnsubscribeSuccessPage;